import { hasValue } from '../lib/utils';
import { AstExpression, AstPrimitive } from '../models/be/db/FormSpecification';
import { isAstExpression, evaluate } from './astInterpreter';

export const evalBoolean = (expression: boolean | AstExpression, values: unknown): boolean => {
	return evalAst(expression, values, true) as boolean;
};

export const evalString = (expression: string | AstExpression, values: unknown): string => {
	return evalAst(expression, values, null) as string;
};

export const evalNumber = (expression: number | AstExpression, values: unknown): number => {
	return evalAst(expression, values, null) as number;
};

export const evalDate = (expression: string | AstExpression, values: unknown): Date => {
	return evalAst(expression, values, null) as Date;
};

export const evalAst = (
	expression: unknown | AstExpression,
	values: unknown,
	defaultValue?: AstPrimitive
): AstPrimitive => {
	if (!hasValue(expression)) {
		return defaultValue;
	}
	if (isAstExpression(expression)) {
		return evaluate(expression as AstExpression, values);
	}
	return expression as AstPrimitive;
};
